import { useNavigate } from 'react-router-dom';
import { useSession } from '../state/session.js';
import { logout } from '../api/auth.js';

interface Props {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export function Topbar({ title, subtitle, action }: Props) {
  const navigate = useNavigate();
  const user = useSession((s) => s.user);
  const refreshToken = useSession((s) => s.refreshToken);
  const clear = useSession((s) => s.clear);

  const onSignOut = async () => {
    if (refreshToken) {
      try {
        await logout(refreshToken);
      } catch {
        /* session already invalid; clear locally regardless */
      }
    }
    clear();
    navigate('/login', { replace: true });
  };

  return (
    <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4">
      <div>
        <h1 className="font-display text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
        {subtitle ? <p className="text-sm text-slate-500">{subtitle}</p> : null}
      </div>
      <div className="flex items-center gap-3">
        {action}
        {user ? (
          <div className="flex items-center gap-3">
            <div className="text-right">
              <p className="text-sm font-semibold leading-tight">{user.name}</p>
              <p className="text-xs text-slate-500">{user.email}</p>
            </div>
            <button type="button" onClick={onSignOut} className="btn-ghost">
              Sign out
            </button>
          </div>
        ) : null}
      </div>
    </header>
  );
}
